
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'App'
})
export default class extends Vue {
  private isRouterAlive=true;
  created() {
  }
  public reload() {
    this.isRouterAlive = false;
    this.$nextTick(() => (this.isRouterAlive = true));
  }
}
